export function Flow() {
  return (
    <section>
      <div className="mx-auto pt-16 pb-16 px-6 lg:pt-32 lg:pb-32 lg:max-w-[1200px]">
        <h2 className="text-center text-lg lg:text-4xl text-textblack font-bold pb-0 lg:pb-6">
          ご導入の流れ
        </h2>
        <p className="text-center text-base text-textblack">
          トライアルはご契約翌日からご利用を開始することが可能です
        </p>
        <div className="mt-14 relative">
          <span className="absolute top-[45%] lg:top-1/2 left-4 lg:left-[2.7rem] bg-[#35478c] h-[80%] w-[3px] -z-10 -translate-y-1/2"></span>

          {/* STEP 01 */}
          <div className="py-6 lg:py-10 lg:flex items-center relative ml-12 lg:ml-28 border-t border-dotted border-primary last-of-type:border-b">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 88 89"
              className="absolute h-12 lg:h-[88px] w-12 lg:w-[88px] top-6 lg:top-1/2 -left-14 lg:-left-28 transform lg:-translate-y-2/4"
            >
              <path
                fill="#35478C"
                d="M44,0.4L44,0.4c24.3,0,44,19.7,44,44l0,0c0,24.3-19.7,44-44,44l0,0c-24.3,0-44-19.7-44-44l0,0
                C0,20.1,19.7,0.4,44,0.4z"
              />
              <g>
                <defs>
                  <rect id="SVGID_1_" x="17" y="17.4" width="54" height="54" />
                </defs>
                <clipPath id="SVGID_00000000932706093572068640000012384740470192490122_">
                  <use xlinkHref="#SVGID_1_" overflow="visible" />
                </clipPath>
                <g clipPath="url(#SVGID_00000000932706093572068640000012384740470192490122_)">
                  <g>
                    <defs>
                      <rect
                        id="SVGID_00000087388394005347230260000004160637472807730571_"
                        x="23.8"
                        y="27.8"
                        width="40.5"
                        height="33.2"
                      />
                    </defs>
                    <clipPath id="SVGID_00000024709083964983593320000000649634419086183564_">
                      <use
                        xlinkHref="#SVGID_00000087388394005347230260000004160637472807730571_"
                        overflow="visible"
                      />
                    </clipPath>
                    <g clipPath="url(#SVGID_00000024709083964983593320000000649634419086183564_)">
                      <path
                        fill="#FFFFFF"
                        d="M64.2,33.4C64.2,33.4,64.2,33.4,64.2,33.4c0-3.1-2.5-5.6-5.6-5.6H29.3c-3.1,0-5.5,2.5-5.6,5.5
                        c0,0,0,0,0,0c0,0,0,0,0,0v22c0,3.1,2.5,5.6,5.6,5.6h29.3c3.1,0,5.6-2.5,5.6-5.6L64.2,33.4C64.2,33.4,64.2,33.4,64.2,33.4
                        L64.2,33.4z M29.3,31.7h29.3c0.7,0,1.2,0.4,1.5,0.9L44,43.9L27.8,32.6C28.1,32,28.7,31.7,29.3,31.7z M58.7,57.2H29.3
                        c-1,0-1.7-0.8-1.7-1.7V37.1l15.3,10.7c0.3,0.2,0.7,0.3,1.1,0.3s0.8-0.1,1.1-0.3l15.3-10.7v18.3C60.4,56.4,59.6,57.2,58.7,57.2
                        L58.7,57.2z"
                      />
                    </g>
                  </g>
                </g>
              </g>
            </svg>
            <div className="w-full lg:w-1/4 lg:mr-[5%]">
              <p className="text-primary text-sm lg:text-lg text-left font-bold font-robot">
                STEP 01
              </p>
              <p className="text-base lg:text-xl text-left font-bold">
                お問合わせ・デモの
                <br />
                ご依頼
              </p>
            </div>
            <div className="w-full mt-2 lg:w-[70%] lg:mt-0">
              <p className="text-sm lg:text-base text-left">
                お客様の課題やご要望などお気軽にお問い合わせください。
                <br />
                製品紹介のデモンストレーションをご希望のお客様には、実際のLAWGUEの操作画面をご覧いただきながらご説明いたします。
              </p>
            </div>
          </div>

          {/* STEP 02 */}
          <div className="py-6 lg:py-10 lg:flex items-center relative ml-12 lg:ml-28 border-t border-dotted border-primary last-of-type:border-b">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 88 89"
              className="absolute h-12 lg:h-[88px] w-12 lg:w-[88px] top-6 lg:top-1/2 -left-14 lg:-left-28 transform lg:-translate-y-2/4"
            >
              <path
                fill="#35478C"
                d="M44,0.9L44,0.9c24.3,0,44,19.7,44,44l0,0c0,24.3-19.7,44-44,44l0,0c-24.3,0-44-19.7-44-44l0,0
                C0,20.6,19.7,0.9,44,0.9z"
              />
              <g>
                <defs>
                  <rect id="SVGID_1_" x="17" y="17.9" width="54" height="54" />
                </defs>
                <clipPath id="SVGID_00000176742692557999616020000000711462284478533302_">
                  <use xlinkHref="#SVGID_1_" overflow="visible" />
                </clipPath>
                <g clipPath="url(#SVGID_00000176742692557999616020000000711462284478533302_)">
                  <g>
                    <defs>
                      <rect
                        id="SVGID_00000011709718094776356870000011361493213999455875_"
                        x="28.2"
                        y="25.7"
                        width="31.5"
                        height="38.5"
                      />
                    </defs>
                    <clipPath id="SVGID_00000116921484229235847360000015029445434840212386_">
                      <use
                        xlinkHref="#SVGID_00000011709718094776356870000011361493213999455875_"
                        overflow="visible"
                      />
                    </clipPath>
                    <g clipPath="url(#SVGID_00000116921484229235847360000015029445434840212386_)">
                      <path
                        fill="#FFFFFF"
                        d="M51,46.2H37c-1,0-1.8,0.8-1.8,1.8c0,1,0.8,1.8,1.8,1.8h14c1,0,1.8-0.8,1.8-1.8C52.8,47,52,46.2,51,46.2z
                        "
                      />
                      <path
                        fill="#FFFFFF"
                        d="M51,53.2H37c-1,0-1.8,0.8-1.8,1.8c0,1,0.8,1.8,1.8,1.8h14c1,0,1.8-0.8,1.8-1.8C52.8,54,52,53.2,51,53.2z
                        "
                      />
                      <path
                        fill="#FFFFFF"
                        d="M37,42.9h3.5c1,0,1.8-0.8,1.8-1.8c0-1-0.8-1.8-1.8-1.8H37c-1,0-1.8,0.8-1.8,1.8C35.2,42,36,42.9,37,42.9
                        z"
                      />
                      <path
                        fill="#FFFFFF"
                        d="M54.4,29.2h-1.7c0-1.9-1.6-3.5-3.6-3.5H38.8c-1.9,0-3.5,1.6-3.6,3.5h-1.7c-2.9,0-5.3,2.4-5.3,5.3v24.4
                        c0,2.9,2.4,5.3,5.3,5.3h20.9c2.9,0,5.3-2.4,5.3-5.3V34.5C59.7,31.5,57.4,29.2,54.4,29.2z M38.8,29.3h10.3v3.3H38.8V29.3z
                        M56.1,58.8c0,0.9-0.7,1.7-1.7,1.7H33.5c-0.9,0-1.7-0.7-1.7-1.7V34.5c0-0.9,0.7-1.7,1.7-1.7h1.7c0,1.9,1.6,3.5,3.5,3.5h10.4
                        c1.9,0,3.5-1.6,3.5-3.5h1.7c0.9,0,1.7,0.7,1.7,1.7L56.1,58.8L56.1,58.8z"
                      />
                    </g>
                  </g>
                </g>
              </g>
            </svg>
            <div className="w-full lg:w-1/4 lg:mr-[5%]">
              <p className="text-primary text-sm lg:text-lg text-left font-bold font-robot">
                <strong>STEP 02</strong>
              </p>
              <p className="text-base lg:text-xl text-left font-bold">
                <strong>お見積り・ご提案</strong>
              </p>
            </div>
            <div className="w-full mt-2 lg:w-[70%] lg:mt-0">
              <p className="text-sm lg:text-base text-left">
                想定のご利用シーンをヒアリングのうえ、ご利用人数や予算に合わせてお見積りをご提示をいたします。
                <br />
                必要に応じてクラウドサービス利用のセキュリティチェックのご要望も承ります。
              </p>
            </div>
          </div>

          {/* STEP 03 */}
          <div className="py-6 lg:py-10 lg:flex items-center relative ml-12 lg:ml-28 border-t border-dotted border-primary last-of-type:border-b">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 88 89"
              className="absolute h-12 lg:h-[88px] w-12 lg:w-[88px] top-6 lg:top-1/2 -left-14 lg:-left-28 transform lg:-translate-y-2/4"
            >
              <path
                fill="#35478C"
                d="M44,0.9L44,0.9c24.3,0,44,19.7,44,44l0,0c0,24.3-19.7,44-44,44l0,0c-24.3,0-44-19.7-44-44l0,0
                C0,20.6,19.7,0.9,44,0.9z"
              />
              <g>
                <defs>
                  <rect id="SVGID_1_" x="17" y="17.9" width="54" height="54" />
                </defs>
                <clipPath id="SVGID_00000148661804320388515110000013116864698969874844_">
                  <use xlinkHref="#SVGID_1_" overflow="visible" />
                </clipPath>
                <g clipPath="url(#SVGID_00000148661804320388515110000013116864698969874844_)">
                  <g>
                    <defs>
                      <rect
                        id="SVGID_00000128472597687306133230000014080538648175903668_"
                        x="23.3"
                        y="25.8"
                        width="41.7"
                        height="38.2"
                      />
                    </defs>
                    <clipPath id="SVGID_00000051380307652936731290000014813624463470689173_">
                      <use
                        xlinkHref="#SVGID_00000128472597687306133230000014080538648175903668_"
                        overflow="visible"
                      />
                    </clipPath>
                    <g clipPath="url(#SVGID_00000051380307652936731290000014813624463470689173_)">
                      <path
                        fill="#FFFFFF"
                        d="M61.6,48.5l-6,5.2l-7.4-7.6c-0.7-0.7-1.7-0.8-2.5-0.3c-0.2,0-0.3,0.1-0.5,0.1c-1,0.4-3.3,1-4.5,0.4
                        c-0.3-0.1-0.5-0.3-0.7-1c-0.1-0.3,0-0.4,0.1-0.5c0.9-1.5,5.7-2.3,7.6-2.6l3,0.3c0.4,0,0.7,0,1-0.2c0.4-0.1,0.8-0.3,1.1-0.6
                        l11.6-12.7c0.7-0.8,0.7-2-0.1-2.8c-0.8-0.7-2-0.7-2.8,0.1L50.5,38.5l-2.6-0.3c-0.2,0-0.3,0-0.5,0l-0.1,0
                        c-2.3,0.4-4.5,0.8-6.4,1.6L37,38.3L26.9,26.5c-0.7-0.8-1.9-0.9-2.8-0.2c-0.8,0.7-0.9,1.9-0.2,2.8l10.4,12.2
                        c0.2,0.2,0.5,0.4,0.7,0.5l1.9,0.8c0,0.1-0.1,0.1-0.1,0.2c-0.7,1.1-0.9,2.3-0.5,3.6c0.4,1.6,1.4,2.8,2.8,3.5c1,0.5,2,0.6,3,0.6
                        c1.8,0,3.4-0.5,4.2-0.8l7.2,7.4c0,0.1-0.1,0.2-0.2,0.3c-0.3,0.3-0.8,0.6-1.4,0.4c-0.5-0.1-1.1-0.1-1.5,0.2
                        c-0.5,0.3-0.8,0.7-0.9,1.3c0,0.1-0.2,0.5-0.6,0.7c-0.7,0.2-1.5-0.4-1.5-0.4c-0.8-0.7-2-0.6-2.7,0.1c-0.2,0.3-0.5,0.4-0.9,0.4
                        c-0.3,0-0.7-0.1-1-0.4c-0.7-0.7-1.9-0.7-2.7,0c-0.3,0.3-0.8,0.5-1.2,0.5c-0.4,0-0.8-0.2-1.1-0.6c0,0-0.1-0.1-0.1-0.1L26.6,48.5
                        c-0.8-0.8-2-0.7-2.8,0c-0.8,0.8-0.7,2,0,2.8l11,10.7c1,1.2,2.4,1.8,3.8,1.9c0.1,0,0.2,0,0.3,0c0.8,0,1.7-0.2,2.4-0.6
                        c0.7,0.4,1.6,0.6,2.4,0.6c0.8,0,1.6-0.2,2.3-0.6c1.1,0.5,2.5,0.8,4,0.3c1.2-0.4,2-1.2,2.5-2c1.4-0.1,2.6-0.7,3.6-1.8
                        c0.7-0.8,1.1-1.8,1.2-2.7c0,0,0,0,0.1,0l6.7-5.8c0.8-0.7,0.9-1.9,0.2-2.8C63.7,47.8,62.5,47.7,61.6,48.5L61.6,48.5z"
                      />
                    </g>
                  </g>
                </g>
              </g>
            </svg>
            <div className="w-full lg:w-1/4 lg:mr-[5%]">
              <p className="text-primary text-sm lg:text-lg text-left font-bold font-robot">
                <strong>STEP 03</strong>
              </p>
              <p className="text-base lg:text-xl text-left font-bold">
                <strong>お申込み</strong>
              </p>
            </div>
            <div className="w-full mt-2 lg:w-[70%] lg:mt-0">
              <p className="text-sm lg:text-base text-left">
                ご希望プラン・アカウント数などの確定後、ご利用に関する契約を締結します。
                <br />
                短期間でのトライアルプランもご用意しております。
              </p>
            </div>
          </div>

          {/* STEP 04 */}
          <div className="py-6 lg:py-10 lg:flex items-center relative ml-12 lg:ml-28 border-t border-dotted border-primary last-of-type:border-b">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 88 89"
              className="absolute h-12 lg:h-[88px] w-12 lg:w-[88px] top-6 lg:top-1/2 -left-14 lg:-left-28 transform lg:-translate-y-2/4"
            >
              <path
                fill="#35478C"
                d="M44,0.9L44,0.9c24.3,0,44,19.7,44,44l0,0c0,24.3-19.7,44-44,44l0,0c-24.3,0-44-19.7-44-44l0,0
                C0,20.6,19.7,0.9,44,0.9z"
              />
              <g>
                <defs>
                  <rect id="SVGID_1_" x="17" y="17.9" width="54" height="54" />
                </defs>
                <clipPath id="SVGID_00000059991536004420158710000018166022804305293501_">
                  <use xlinkHref="#SVGID_1_" overflow="visible" />
                </clipPath>
                <g clipPath="url(#SVGID_00000059991536004420158710000018166022804305293501_)">
                  <g>
                    <defs>
                      <rect
                        id="SVGID_00000111913469655702781350000007409977313033526446_"
                        x="23.8"
                        y="24.6"
                        width="40.5"
                        height="40.6"
                      />
                    </defs>
                    <clipPath id="SVGID_00000123441927364520576350000007719572496047466413_">
                      <use
                        xlinkHref="#SVGID_00000111913469655702781350000007409977313033526446_"
                        overflow="visible"
                      />
                    </clipPath>
                    <g clipPath="url(#SVGID_00000123441927364520576350000007719572496047466413_)">
                      <path
                        fill="#FFFFFF"
                        d="M58.7,24.6H29.3c-3.1,0-5.6,2.5-5.6,5.6v19.4c0,3.1,2.5,5.6,5.6,5.6h6.2l-1.3,6.5
                        c-0.2,0.9,0,1.8,0.6,2.5c0.6,0.7,1.4,1.1,2.3,1.1h13.8c0.9,0,1.7-0.4,2.3-1.1c0.6-0.7,0.8-1.6,0.6-2.5l-1.3-6.5h6.2
                        c3.1,0,5.6-2.5,5.6-5.6V30.2C64.2,27.1,61.7,24.6,58.7,24.6z M38.2,61.4l1.2-6h9.1l1.2,6H38.2z M60.4,49.6c0,1-0.8,1.7-1.7,1.7
                        H29.3c-1,0-1.7-0.8-1.7-1.7V30.2c0-1,0.8-1.7,1.7-1.7h29.3c1,0,1.7,0.8,1.7,1.7V49.6z"
                      />
                    </g>
                  </g>
                </g>
              </g>
            </svg>
            <div className="w-full lg:w-1/4 lg:mr-[5%]">
              <p className="text-primary text-sm lg:text-lg text-left font-bold font-robot">
                <strong>STEP 04</strong>
              </p>
              <p className="text-base lg:text-xl text-left font-bold">
                <strong>ご利用開始</strong>
              </p>
            </div>
            <div className="w-full mt-2 lg:w-[70%] lg:mt-0">
              <p className="text-sm lg:text-base text-left">
                ご利用者様のメールアドレスの確認、アカウントの発行を経てキックオフミーティングを実施いたします。より具体的なお客様の業務課題のヒアリングをさせていただき、最適な運用プランをご提案いたします。
              </p>
            </div>
          </div>

          {/* STEP 05 */}
          <div className="py-6 lg:py-10 lg:flex items-center relative ml-12 lg:ml-28 border-t border-dotted border-primary last-of-type:border-b">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 88 89"
              className="absolute h-12 lg:h-[88px] w-12 lg:w-[88px] top-6 lg:top-1/2 -left-14 lg:-left-28 transform lg:-translate-y-2/4"
            >
              <path
                fill="#35478C"
                d="M44,0.9L44,0.9c24.3,0,44,19.7,44,44l0,0c0,24.3-19.7,44-44,44l0,0c-24.3,0-44-19.7-44-44l0,0
                C0,20.6,19.7,0.9,44,0.9z"
              />
              <g>
                <defs>
                  <rect id="SVGID_1_" x="17" y="17.9" width="54" height="54" />
                </defs>
                <clipPath id="SVGID_00000013883577753692560060000014512270604747730308_">
                  <use xlinkHref="#SVGID_1_" overflow="visible" />
                </clipPath>
                <g clipPath="url(#SVGID_00000013883577753692560060000014512270604747730308_)">
                  <g>
                    <defs>
                      <rect
                        id="SVGID_00000061450141462611858810000001644034022423003520_"
                        x="23.8"
                        y="24.6"
                        width="40.5"
                        height="40.6"
                      />
                    </defs>
                    <clipPath id="SVGID_00000136388538449753874120000002658170814216950163_">
                      <use
                        xlinkHref="#SVGID_00000061450141462611858810000001644034022423003520_"
                        overflow="visible"
                      />
                    </clipPath>
                    <g clipPath="url(#SVGID_00000136388538449753874120000002658170814216950163_)">
                      <path
                        fill="#FFFFFF"
                        d="M64.2,43.6C63.7,32.9,54.8,24.3,44,24.3s-19.7,8.5-20.2,19.2c0,0.2,0,0.3,0,0.5v13.1
                        c0,0.2,0,0.3,0.1,0.5c0,0,0,0.1,0,0.1c0,0.2,0,2.3,1.5,3.8c0.7,0.7,2,1.6,4.3,1.6h8.1c0.8,1.1,2.1,1.7,3.6,1.7h0
                        c2.5,0,4.6-2.1,4.6-4.6c0-2.5-2.1-4.6-4.6-4.6c-2.2,0-4.1,1.6-4.5,3.7h-7.2c-0.5,0-1.9,0-1.9-1.5c0-0.2,0-0.3-0.1-0.5
                        c0-0.1,0-0.1,0-0.2v-1.5c0.7,0.3,1.4,0.4,2.1,0.4h2c3.3,0,6-2.7,6-6V44c0-3.3-2.7-6-6-6h-2c-0.3,0-0.6,0-0.9,0.1
                        c2.5-5.8,8.3-9.9,15.1-9.9s12.6,4.1,15.1,9.9c-0.3,0-0.6-0.1-0.9-0.1h-2c-3.3,0-6,2.7-6,6v6.1c0,3.3,2.7,6,6,6h2
                        c2.7,0,5-1.8,5.7-4.3c0.2-0.3,0.3-0.6,0.3-0.9V44C64.2,43.9,64.2,43.7,64.2,43.6L64.2,43.6z M41.2,59.5c0.4,0,0.8,0.3,0.8,0.8
                        c0,0.4-0.3,0.8-0.8,0.8h0c-0.4,0-0.8-0.3-0.8-0.8C40.4,59.9,40.7,59.5,41.2,59.5L41.2,59.5z M29.8,41.9h2c1.2,0,2.1,1,2.1,2.1
                        v6.1c0,1.2-1,2.1-2.1,2.1h-2c-1.2,0-2.1-1-2.1-2.1v-5.6c0-0.3,0-0.6,0-0.9C27.8,42.6,28.7,41.9,29.8,41.9L29.8,41.9z M58.3,52.3
                        h-2c-1.2,0-2.1-1-2.1-2.1v-6.1c0-1.2,1-2.1,2.1-2.1h2c1,0,1.9,0.7,2.1,1.7c0,0.3,0,0.6,0,0.9v5.6C60.4,51.3,59.4,52.3,58.3,52.3
                        L58.3,52.3z"
                      />
                    </g>
                  </g>
                </g>
              </g>
            </svg>
            <div className="w-full lg:w-1/4 lg:mr-[5%]">
              <p className="text-primary text-sm lg:text-lg text-left font-bold font-robot">
                <strong>STEP 05</strong>
              </p>
              <p className="text-base lg:text-xl text-left font-bold">
                <strong>サポート</strong>
              </p>
            </div>
            <div className="w-full mt-2 lg:w-[70%] lg:mt-0">
              <p className="text-sm lg:text-base text-left">
                専属のカスタマーサクセス担当と定期的にフォローアップミーティングをしていただき、ご利用上の不明点の解消や新機能のご紹介をさせていただきます。
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}
